import React from 'react'
import PropTypes from 'prop-types'
import { CYCLE_DETAIL, INSTRUMENT_EMPTY_VALUE } from '../utils/constants'

const formatCycleValue = (value) =>
  value != null && value !== '' ? value : INSTRUMENT_EMPTY_VALUE

const CycleDetailContent = ({ range, selectedDay }) => {
  const cycleData = range.cycleData || {}
  const duration =
    range.endDay != null && range.startDay != null ? range.endDay - range.startDay + 1 : null
  const durationDisplay = duration != null ? `${duration}${CYCLE_DETAIL.DAYS_SUFFIX}` : null
  const offsetMinutes = cycleData.start_time
  const offsetDisplay =
    offsetMinutes != null && offsetMinutes !== ''
      ? `${Math.floor(Number(offsetMinutes) / 1440)}${CYCLE_DETAIL.DAYS_SUFFIX}`
      : null

  const renderRow = (label, value) => (
    <div className='study-timeline-detail-row' key={label}>
      <span className='study-timeline-detail-label'>{label}:</span>
      <span className='study-timeline-detail-value'>{formatCycleValue(value)}</span>
    </div>
  )

  // Order: Cycle Name, Duration, Anchor, Offset, Study Day. No value → "-"
  return (
    <div className='study-timeline-detail-content'>
      {renderRow(CYCLE_DETAIL.CYCLE_NAME, range.cycleName)}
      {renderRow(CYCLE_DETAIL.DURATION, durationDisplay)}
      {renderRow(CYCLE_DETAIL.ANCHOR, cycleData.metadata?.anchor_option)}
      {renderRow(CYCLE_DETAIL.OFFSET, offsetDisplay)}
      {renderRow(CYCLE_DETAIL.STUDY_DAY, selectedDay)}
    </div>
  )
}

CycleDetailContent.propTypes = {
  range: PropTypes.shape({
    cycleId: PropTypes.string,
    cycleName: PropTypes.string,
    startDay: PropTypes.number,
    endDay: PropTypes.number,
    cycleData: PropTypes.object,
  }).isRequired,
  selectedDay: PropTypes.number.isRequired,
}

export default CycleDetailContent
